import PropTypes, { element, func } from "prop-types";
import React, { useContext, useEffect, useState } from "react";

import "../../assets/scss/style.css";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import "flatpickr/dist/themes/material_blue.css";

import { withTranslation } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { alerShow } from "admin/commonFunction";
import { addCommision, getAllCommision } from "services/transactionServices";

const Commission = (props) => {
  const [commission, setCommission] = useState({
    value: "",
    name: "",
    id: "",
  });
  console.log(commission, "commission");
  // Form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      value: commission?.value ? commission?.value : "",
      name: commission?.name ? commission?.name : "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Required"),
      value: Yup.string().required("Required"),
    }),
    onSubmit: (values, actions) => {
      let collectionData = {
        name: values.name,
        value: values.value,
      };
      let updatedData = {
        name: values.name,
        value: values.value,
        id: commission?.id,
      };
      addCommision(commission?.id ? { updatedData } : collectionData)
        .then(function (response) {
          alerShow("Success", response.message);
          fetchCommission();
        })
        .catch(function (error) {
          alerShow("Error", error.response.data.error, "error");
        });
    },
  });
  const fetchCommission = async () => {
    try {
      const responce = await getAllCommision();
      if (responce.status == 200) {
        const { name, value, id } = responce.data;
        setCommission({
          name,
          value,
          id,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCommission();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Row>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Commission"} />
          <Col xs="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation create-vendor"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row>
                    <Col sm="6">
                      <Label htmlFor="name"> Name</Label>
                      <Input
                        id="name"
                        type="text"
                        className="form-control"
                        placeholder="enter name..."
                        name="name"
                        value={validation?.values?.name}
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col sm="6">
                      <Label htmlFor="value"> Commission </Label>
                      <Input
                        id="value"
                        name="value"
                        type="text"
                        className="form-control"
                        placeholder="please enter commission..."
                        value={validation?.values?.value}
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                      />
                      {validation.touched.value && validation.errors.value ? (
                        <FormFeedback type="invalid">
                          {validation.errors.value}
                        </FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                  <div className="d-flex flex-wrap gap-2 mt-4">
                    <Button type="submit" color="primary" className="btn ">
                      Create
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

Commission.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Commission);
